import { modifyCustomerHomeAddCountJobs } from "./modifyCustomerHomeAddCountJobs";
import { addSignatureModal } from "./addSignatureModal";

export const MIGRATIONS_DEBUG = true;
export const migrations = {
  0: (state) => state,
  1: modifyCustomerHomeAddCountJobs,
  2: addSignatureModal,
}